import React from 'react';
import { CloseOutlined } from '@ant-design/icons';
import { Button } from 'antd';

interface SidePanelProps {
	visible: boolean;
	onClose: () => void;
	title?: string;
	subtitle?: string;
	children: React.ReactNode;
	width?: number | string;
	closable?: boolean;
	maskClosable?: boolean;
	className?: string;
	autoHeight?: boolean;
}

const SidePanel: React.FC<SidePanelProps> = ({
	visible,
	onClose,
	title,
	subtitle,
	children,
	width = 500,
	closable = true,
	maskClosable = false,
	className = '',
	autoHeight = false,
}) => {
	if (!visible) return null;

	const handleMaskClick = () => {
		if (maskClosable) {
			onClose();
		}
	};

	const handlePanelClick = (e: React.MouseEvent) => {
		e.stopPropagation();
	};

	const widthStyle = typeof width === 'number' ? `${width}px` : width;

	return (
		<>
			<style>{`
				@keyframes slideIn {
					from { transform: translateX(100%); }
					to { transform: translateX(0); }
				}
			`}</style>
			<div
				className={`fixed inset-0 z-[1000] flex justify-end pointer-events-none ${autoHeight ? 'items-start' : ''}`}
				style={{ top: '85px', right: '10px' }}
				onClick={handleMaskClick}
			>
			<div
				className={`relative bg-white shadow-[-2px_0_8px_rgba(0,0,0,0.15)] flex flex-col pointer-events-auto overflow-hidden rounded-md ${className}`}
				style={{
					width: widthStyle,
					height: autoHeight ? 'auto' : 'calc(99vh - 85px)',
					maxHeight: autoHeight ? 'calc(99vh - 85px)' : undefined,
					animation: 'slideIn 0.3s ease-out'
				}}
				onClick={handlePanelClick}
			>
				{(title || subtitle || closable) && (
					<div className="flex justify-between items-center px-5 py-5 bg-white flex-shrink-0">
						<div className="flex flex-col">
							{title && <h2 style={{ fontSize: '20px', fontWeight: '700', margin: 0, color: '#1a1a2e' }}>{title}</h2>}
							{subtitle && <p style={{ fontSize: '11px', fontWeight: '600', color: '#9ca3af', letterSpacing: '0.5px', margin: '4px 0 0 0', textTransform: 'uppercase' }}>
								{subtitle}
							</p>}
						</div>
						{closable && (
							<Button
								type="text"
								icon={<CloseOutlined />}
								onClick={onClose}
								className="text-gray-500 hover:text-gray-800 hover:bg-gray-100"
							/>
						)}
					</div>
				)}
				<div className={`${autoHeight ? '' : 'flex-1'} overflow-y-auto overflow-x-hidden`}>
					{children}
				</div>
			</div>
			</div>
		</>
	);
};

export default SidePanel;
